import { Box, Tooltip, Typography, styled } from "@mui/material";

import CopyToClipboard from "components/CopyToClipboard";
import { separateTextFromCenter } from "utils/helpers/text";

export function Address({ data }) {
  return (
    <>
      {data.address ? (
        <BoxAddress>
          <Tooltip placement="bottom" title={data?.address}>
            <Typography variant="subtitle1" pr={1}>
              {separateTextFromCenter(data.address)}
            </Typography>
          </Tooltip>

          <CopyToClipboard value={data.address} />
        </BoxAddress>
      ) : (
        " - "
      )}
    </>
  );
}
const BoxAddress = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export default Address;
